<template>
	<div
		class="ao-map-preview-wrapper"
		:class="{'ao-map-preview-wrapper--loading': loading }"
	>
		<div
			v-if="loading"
			class="ao-map-preview__loading"
		>
			<v-progress-circular
				indeterminate
				size="64"
				color="primary"
			/>
		</div>

		<!-- v-show="!loading" -->
		<div
			:style="{ opacity: loading ? 0 : 1, }"
			class="w-100 h-100 map"
			ref="map"
		></div>
	</div>
</template>
<script>
const MAP_STYLES = {
    background_shapes: {
        'fill-color': '#7C7C7C',
        'fill-opacity': 0.25,
        'line-color': '#A2A2A2',
        'line-width': 1.5
    },
    main_shapes: {
        'fill-color': '#83C72C',
        'fill-opacity': 0.5,
        'line-color': '#83C72C',
        'line-width': 1.5
    },
    overlay_shapes: {
        'fill-color': '#c75a2c',
        'fill-opacity': 0.5,
        'line-color': '#c7482c',
        'line-width': 1.5

    },
    lines: {
        'stroke': '#000000',
        'stroke-width': 0,
        'line': '#FFFFFF',
        'line-width': 2
    },
    markers: {},
    // TITLES TEMPORARY DISABLED
    titles: {
        'text-color': 'white', // 'black',
        'text-halo-color': '#7C7C7C', // 'white',
        'text-halo-width': 3,
        'text-halo-blur': 0
    }
};

import * as turf from '@turf/turf';
import maplibregl from 'maplibre-gl'

import useDefaultSources from '@/config/map/defaultSources'

export default {
	name: 'AoMapPreview',
	props: {
		geojsonData: {
			type: Object,
			default: () => ({})
		},
		showTitles: {
			type: Boolean,
			default: undefined
		},
		loading: {
			type: Boolean,
			default: false
		},
		bitmapFeature: {
			type: Object,
			default: () => (null),
		},
	},
	setup() {
		const { defaultMapStyle } = useDefaultSources()

		return {
			defaultMapStyle
		}
	},
	data: () => ({
		map: null
	}),
	watch: {
		geojsonData: {
			handler: function (geojsonData) {
				if (geojsonData) {
					this.destroyMap();
					this.generateMapPreview(this.$refs.map, geojsonData.feature_collection, geojsonData.bbox, this.bitmapFeature);
				}
			},
			deep: true,
		},
		showTitles: {
			handler: function (showTitles) {
				if (showTitles !== undefined) {
					this.generateMapPreview(this.$refs.map, this.geojson, null, this.bitmapFeature);
				}
			},
			deep: true
		},
		loading: {
			handler: function () {
				window.dispatchEvent(new Event('resize'));
			},
		}
	},
	methods: {
		generateMapPreview(container, geojson, bbox = null, bitMap = null) {
			// get view bounds
			const geojsonBounds = geojson ? turf.bbox(geojson) : null;
			bbox = geojsonBounds && !geojsonBounds?.some(v => v === Infinity) ? geojsonBounds : bbox;

			this.map = this.map || new maplibregl.Map({
				container: container,
				style: this.defaultMapStyle,
				pitch: 25,
				bearing: 45,
				scrollZoom: false,
				boxZoom: false,
				dragRotate: false,
				dragPan: false,
				keyboard: false,
				doubleClickZoom: false,
				touchZoomRotate: false
			});

			if (!geojson) return;

			// ADJUST PADDING AND PITCH

			let container_element = container;

			let horizontal_paddings = 20;
			let vertical_paddings = 10;

			let show_titles = false;
			let pitch = 40;

			if (container_element.clientWidth > 300 && container_element.clientHeight > 100) {
				show_titles = true;
			}
			if (container_element.clientWidth > 400) {
				// horizontal_paddings = 30;
				horizontal_paddings = 45;
			} else if (container_element.clientWidth > 300) {
				// horizontal_paddings = 25;
				horizontal_paddings = 40;
			} else if (container_element.clientWidth > 200) {
				// horizontal_paddings = 20;
				horizontal_paddings = 35;
			} else if (container_element.clientWidth > 100) {
				// horizontal_paddings = 20;
				horizontal_paddings = 35;
			}
			if (container_element.clientHeight > 400) {
				// vertical_paddings = 30;
				vertical_paddings = 35;
				pitch = 25;
			} else if (container_element.clientHeight > 300) {
				// vertical_paddings = 25;
				vertical_paddings = 30;
				pitch = 25;
			} else if (container_element.clientHeight > 200) {
				// vertical_paddings = 20;
				vertical_paddings = 25;
				pitch = 25;
			} else if (container_element.clientHeight > 100) {
				// vertical_paddings = 20;
				vertical_paddings = 25;
				pitch = 30;
			}
			if (bbox && bbox.length === 4) {
				this.map.fitBounds([
					[bbox[0], bbox[1]],
					[bbox[2], bbox[3]]
				], {
					padding: {
						top: vertical_paddings,
						bottom: vertical_paddings,
						left: horizontal_paddings,
						right: horizontal_paddings
					},
					animate: false
				});
			} else if (geojsonBounds && !geojsonBounds?.some(v => v === Infinity)) {
				this.map.fitBounds([
					[geojsonBounds[0], geojsonBounds[1]],
					[geojsonBounds[2], geojsonBounds[3]]
				], {
					padding: {
						top: vertical_paddings,
						bottom: vertical_paddings,
						left: horizontal_paddings,
						right: horizontal_paddings
					},
					animate: false // Анимация при изменении масштабирования и центра (необязательно)
				});
			}


			// ADD LAYERS

			this.map.on('load', () => {

				// this.map.setPitch(pitch);
				// this.map.setBearing(25);

				this.map.addSource('preview_source', {
					'type': 'geojson',
					'data': geojson
				});

				if (bitMap) {
					this.map.addSource('satellite-image', {
						type: 'image',
						url: bitMap.properties.image, // URL изображения
						coordinates: [
							[bitMap.properties.bbox[0], bitMap.properties.bbox[3]], // верхний левый угол
							[bitMap.properties.bbox[2], bitMap.properties.bbox[3]], // верхний правый угол
							[bitMap.properties.bbox[2], bitMap.properties.bbox[1]], // нижний правый угол
							[bitMap.properties.bbox[0], bitMap.properties.bbox[1]]  // нижний левый угол
						]
					})
				}

				this.map.addLayer({
					'id': 'background_shapes',
					'type': 'fill',
					'source': 'preview_source',
					'paint': {
						'fill-color': MAP_STYLES.background_shapes['fill-color'],
						'fill-opacity': MAP_STYLES.background_shapes['fill-opacity'],
					},
					'filter': ['==', 'layer', 'background_shapes']
				});
				this.map.addLayer({
					'id': 'background_shapes_outline',
					'type': 'line',
					'source': 'preview_source',
					'paint': {
						'line-color': MAP_STYLES.background_shapes['line-color'],
						'line-width': MAP_STYLES.background_shapes['line-width']
					},
					'filter': ['==', 'layer', 'background_shapes']
				});


				this.map.addLayer({
					'id': 'main_shapes',
					'type': 'fill',
					'source': 'preview_source',
					'paint': {
						// 'fill-color': MAP_STYLES.main_shapes['fill-color'],
						// 'fill-color': [
						// 	'get',
						// 	'fill', // Access the fillColor property in the feature's properties
						// ],
						'fill-color': [
							'coalesce', // This expression selects the first non-null value
							['get', 'fill'], // Try to get the 'fillColor' property
							MAP_STYLES.main_shapes['fill-color'] // If 'fillColor' is missing, use 'default-color'
						],
						'fill-opacity': MAP_STYLES.main_shapes['fill-opacity']
					},
					'filter': ['==', 'layer', 'main_shapes']
				});
				this.map.addLayer({
					'id': 'main_shapes_outline',
					'type': 'line',
					'source': 'preview_source',

					'paint': {
						// 'line-color': MAP_STYLES.main_shapes['line-color'],
						// 'fill-color': [
						// 	'get',
						// 	'stroke', // Access the fillColor property in the feature's properties
						// ],
						'line-color': [
							'coalesce', // This expression selects the first non-null value
							['get', 'stroke'], // Try to get the 'fillColor' property
							MAP_STYLES.main_shapes['line-color'] // If 'fillColor' is missing, use 'default-color'
						],
						'line-width': MAP_STYLES.main_shapes['line-width']
					},
					'filter': ['==', 'layer', 'main_shapes']
				});


				this.map.addLayer({
					'id': 'overlay_shapes',
					'type': 'fill',
					'source': 'preview_source',
					'paint': {
						'fill-color': MAP_STYLES.overlay_shapes['fill-color'],
						'fill-opacity': MAP_STYLES.overlay_shapes['fill-opacity']
					},
					'filter': ['==', 'layer', 'overlay_shapes']
				});
				this.map.addLayer({
					'id': 'overlay_shapes_outline',
					'type': 'line',
					'source': 'preview_source',
					'paint': {
						'line-color': MAP_STYLES.overlay_shapes['line-color'],
						'line-width': MAP_STYLES.overlay_shapes['line-width']
					},
					'filter': ['==', 'layer', 'overlay_shapes']
				});

				//TEMPORARY DISABLED OUTLINE
				this.map.addLayer({
					'id': 'line_outline',
					'type': 'line',
					'source': 'preview_source',
					'layout': {
						'line-join': 'round',
						'line-cap': 'round'
					},
					'paint': {
						'line-color': MAP_STYLES.lines.stroke,
						'line-width': MAP_STYLES.lines['stroke-width']
					},
					'filter': ['==', 'layer', 'lines']
				});
				this.map.addLayer({
					'id': 'lines',
					'type': 'line',
					'source': 'preview_source',
					'layout': {
						'line-join': 'round',
						'line-cap': 'round'
					},
					'paint': {
						'line-color': MAP_STYLES.lines.line,
						'line-width': MAP_STYLES.lines['line-width']
					},
					'filter': ['==', 'layer', 'lines']
				});


				geojson.features.forEach((feature) => {
					if (feature.properties.layer === 'markers') {
						const marker = new maplibregl.Marker({
								scale: 1,
								draggable: false,
								pitchAlignment: 'auto',
								color: '#FF0000'
							}
						)
							.setLngLat(feature.geometry.coordinates)
							.addTo(this.map);
					}
				});


				// TEMPORARY DISABLED TITLES
				if (this.showTitles ?? show_titles) {
					this.map.addLayer({
						'id': 'titles',
						'type': 'symbol',
						'source': 'preview_source',
						'layout': {
							'text-field': ['get', 'title'],
							'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
							'text-size': 14,
							'text-anchor': 'center',
							'text-offset': [0, 0]
						},
						'paint': {
							'text-color': MAP_STYLES.titles['text-color'],
							'text-halo-color': MAP_STYLES.titles['text-halo-color'],
							'text-halo-width': MAP_STYLES.titles['text-halo-width'],
							'text-halo-blur': MAP_STYLES.titles['text-halo-blur']
						},
						'filter': ['==', 'layer', 'titles']
					});
				}

				if (bitMap) {
					this.map.addLayer({
						id: 'satellite-image-layer',
						type: 'raster',
						source: 'satellite-image',
						// paint: {
						// 	'raster-opacity': 0.8 // Прозрачность изображения
						// }
					})
				}

			});

			setTimeout(() => {
				const zoom = this.map.getZoom();

				if (zoom > 15) {
					this.map.setZoom(15);
				}
			}, 100);
		},
		destroyMap() {
			if (this.map) {
				this.map.remove();
				this.map = null;
				this.$refs.map.innerHTML = '';
			}
		}
	},
	mounted() {
		this.generateMapPreview(this.$refs.map, this.geojsonData?.feature_collection, this.geojsonData?.bbox, this.bitmapFeature);
	},
	beforeUnmount() {
		this.destroyMap();
	}
}
</script>
<style>
    .maplibregl-ctrl-attrib {
        display: none !important;
    }

    .maplibregl-ctrl-logo {
        display: none !important;
    }

	.ao-map-preview-wrapper {
		width: 100%;
		height: 200px;
	}

	.ao-map-preview-wrapper--loading {
		position: relative;
	}

	.ao-map-preview__loading {
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		background-color: rgb(var(--v-theme-lightGrey));
		z-index: 100;
		border-radius: 4px;
	}
</style>
